import { Col } from "antd";

const PaymentCard = (props) => {
    const { title, value, icon } = props
    return (
        <Col span={6}>
            <div style={{position:"relative",background:"#158cba",color:"white", textAlign: "left", padding: "5px 10px", borderRadius: 10, boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.75)" }}>
                <span style={{position:'absolute',right:10, top:10,fontSize: '26px'}}>{icon}</span>
                <h3>{title}</h3>
                <h4>{value}</h4>
            </div>
        </Col>
    );
}

export default PaymentCard;